export const DEV_BASE_URL = 'https://achieversiq.com/api/'
// export const DEV_BASE_URL = 'http://0.0.0.0:8000/api/'
export const SOURCE = 'website'

export const classes = [
    6,
    7,
    8,
    9,
    10,
    11,
    12
  ];

export const LEAD_STATUS_MAP = {
    100: "New Lead",
    200: "Assigned",
    300: "In Progress",
    301: "Follow Up",
    400: "Converted",
    500: "Dead"
}

export const LEAD_SOURCE_MAP = {
    1: "Web",
    2: "Organic",
    3: "WalkIn",
    4: "Inbound",
    5: "Call",
    6: "Sales"
}

export const LEAD_STATUS_BG = {
    1: "primary",
    200: "success",
    300: "warning",
    400: "success",
    500: "danger"
}

export const PRIORITY_MAP = {
    0: 'High',
    1: 'Cold',
    2: 'Duplicate'
}